// 型ガード関数 - APIレスポンスの型チェック
import type { DeviceInventoryAssignee } from '../../_root/packages/-components/DeviceInventoryOperation/type';
import type { ApiSelfReportResult, ApiSelfReportTarget } from './types';

/**
 * セルフレポート対象デバイスの型ガード
 */
export function isSelfReportTarget(obj: unknown): obj is ApiSelfReportTarget {
  if (!obj || typeof obj !== 'object') return false;
  const target = obj as Record<string, unknown>;

  // 必須フィールドの検証（APIから文字列として返される）
  if (typeof target.instanceId !== 'string' || typeof target.taskInstanceId !== 'string' || typeof target.deviceTaskId !== 'string' || typeof target.requestId !== 'string') {
    return false;
  }

  // device オブジェクトの検証
  if (!target.device || typeof target.device !== 'object') {
    return false;
  }
  const device = target.device as Record<string, unknown>;
  if (typeof device.id !== 'string' || typeof device.name !== 'string') {
    return false;
  }

  // assignedPerson の検証（null または有効なオブジェクト）
  if (target.assignedPerson !== null && target.assignedPerson !== undefined) {
    if (typeof target.assignedPerson !== 'object') {
      return false;
    }
    const assignedPerson = target.assignedPerson as DeviceInventoryAssignee;
    if (typeof assignedPerson.id !== 'string' || typeof assignedPerson.name !== 'string') {
      return false;
    }
  }
  return true;
}

/**
 * セルフレポート結果の型ガード
 */
export function isSelfReportResult(obj: unknown): obj is ApiSelfReportResult {
  if (!obj || typeof obj !== 'object') return false;
  const result = obj as Record<string, unknown>;

  // 必須フィールドの検証（APIから文字列として返される）
  if (typeof result.instanceId !== 'string' || typeof result.taskInstanceId !== 'string' || typeof result.deviceTaskId !== 'string' || typeof result.requestId !== 'string' || typeof result.anchorDate !== 'string') {
    return false;
  }

  // device オブジェクトの検証
  if (!result.device || typeof result.device !== 'object') {
    return false;
  }
  const device = result.device as Record<string, unknown>;
  if (typeof device.id !== 'string' || typeof device.name !== 'string') {
    return false;
  }

  // assignedPerson の検証（null または有効なオブジェクト）
  if (result.assignedPerson !== null && result.assignedPerson !== undefined) {
    if (typeof result.assignedPerson !== 'object') {
      return false;
    }
    const assignedPerson = result.assignedPerson as Record<string, unknown>;
    if (typeof assignedPerson.id !== 'string' || typeof assignedPerson.name !== 'string') {
      return false;
    }
  }

  // selfReport の検証（null または有効なオブジェクト）
  if (result.selfReport !== null && result.selfReport !== undefined) {
    if (typeof result.selfReport !== 'object') {
      return false;
    }
    // selfReport の詳細検証は省略（オプショナルフィールドが多いため）
  }
  return true;
}